<script setup>
import {useRoute, useRouter} from "vue-router";
import { ref } from 'vue';
const router = useRouter()
const routes = router.getRoutes();
const currentRoute = useRoute();
import state from './CourseFlow/state';

let currentIndex = ref(0);
router.afterEach(() => {
  routes.forEach((route, index) => {
    if (route.path === currentRoute.path) {
      currentIndex.value = index;
    }
  })

  let flowDataLayerEvent = '';
  if (state.value.info.flowType === 'course') {
    flowDataLayerEvent = `InschrijvenCursusStap${currentIndex.value + 1}`;
  }
  if (state.value.info.flowType === 'symposium') {
    flowDataLayerEvent = `InschrijvenSymposiumStap${currentIndex.value + 1}`;
  }

  plausible(flowDataLayerEvent)
})


</script>

<template>
  <div class="form-bg"></div>


  <div class="block block--form-header">
    <div class="block__container">
      <div class="block__row">

        <div class="form__header">

          <div class="form__logo-wrapper">
            <a href="/" id="flow_logo">
              <img class="inject form__logo" src="/app/themes/actadental/dist/images/acta-logo.svg" alt="Logo Acta"/>
            </a>
          </div>


          <div class="form__nav">
            <div class="form__nav-inner">

              <router-link :to="routes[currentIndex - 1]" class="link-stepback" id="flow_stepback" v-if="currentIndex > 0">
                  <img class="inject img-stepback" src="/app/themes/actadental/dist/images/pijltje.svg" alt="knop stap terug"/>
                  <span>Vorige stap</span>
              </router-link>

              <div class="form__steps-mobile">
                <div class="steps-counter">
                  {{ currentIndex + 1 }} / {{ routes.length }}
                </div>
              </div>

              <a class="link-cancelform" href="#" data-toggle="modal" data-target="#modal--cancelform" id="flow_cancel">
                <img class="inject img-cancelform" src="/app/themes/actadental/dist/images/kruisje.svg" alt="verwijderknop"/>
                <span>Inschrijven</span> Annuleren
              </a>
            </div>
          </div>

        </div>

        <div class="form__steps-mobile-title">
          <p>Stap {{ currentIndex + 1 }}</p>
        </div>

      </div>
    </div>
  </div>

  <div class="modal modal--cancelform fade" id="modal--cancelform" tabindex="-1" role="dialog" aria-labelledby="myModalLabel">
    <div class="modal-dialog" role="document">
      <div class="modal-content">

        <div class="cancelformmodal__info">
          <h4>Inschrijven annuleren</h4>
          <p>Weet u zeker dat u uw inschrijving wilt annuleren?</p>
          <div class="buttons">
            <a :href="state.info.referrerUrl" class="button button--sm button--red">
              <div class="button__text">
                Inschrijven annuleren
              </div>
            </a>
            <a href="#" class="button button--sm button--grey button--close-modal-js" data-dismiss="modal">
              <div class="button__text">
                Terug
              </div>
            </a>
          </div>
        </div>

      </div>
    </div>
  </div>



  <div class="block block--form-wrapper">
    <div class="block__container">
      <div class="block__row">

        <div class="form__steps">
          <div class="form__steps-inner">
            <ul>
              <li :class="route.path === $route.path ? 'current-step active-step': ''" v-for="(route, index) in routes">
                <router-link :to="route.path"><span>{{index + 1}}</span> <p>{{ route.meta.name }}</p></router-link>
              </li>
            </ul>
          </div>
        </div>


        <div class="form__section">
          <div class="block__row">
            <div class="form__form-inner">
              <div class="form__form">
                <div class="entry__step" :class="currentRoute.name === 'confirmation' ? 'entry__step--lg' : ''">
                  <router-view></router-view>
                </div>
              </div>
              <div class="form__footer">
                <p><img class="inject cancel-form" src="/app/themes/actadental/dist/images/vinkje.svg" alt="icoon vinkje"/>Annuleren kan altijd. Bekijk onze <a href="https://acta-de.nl/algemene-voorwaarden/" target="_blank">annuleringsvoorwaarden</a>.</p>
                <p><img class="inject cancel-form" src="/app/themes/actadental/dist/images/vinkje.svg" alt="icoon vinkje"/>Heeft u <a href="https://acta-de.nl/klachten/" target="_blank">klachten</a>?</p>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>